var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingApprovals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "deadline_1378330",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.938,
    height: 60,
    viewBox: "0 0 48.938 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12142",
    "data-name": "Path 12142",
    d: "M61.735,7.5H30.84V20.723a13.851,13.851,0,0,0,5.976,11.471l5.689,3.737a.871.871,0,0,1,0,1.441l-5.689,3.737A13.852,13.852,0,0,0,30.84,52.58V65.8h30.9V52.58a13.851,13.851,0,0,0-5.976-11.471L50.07,37.372a.871.871,0,0,1,0-1.441l5.689-3.737a13.852,13.852,0,0,0,5.976-11.471Zm0,0",
    transform: "translate(-27.351 -6.652)",
    fill: "#fafaff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12143",
    "data-name": "Path 12143",
    d: "M164.741,35.931l5.689-3.737a13.852,13.852,0,0,0,5.976-11.471V7.5h-6.2V20.723a13.851,13.851,0,0,1-5.976,11.471l-2.648,1.739a3.283,3.283,0,0,0,0,5.437l2.648,1.739A13.852,13.852,0,0,1,170.2,52.58V65.8h6.2V52.58a13.851,13.851,0,0,0-5.976-11.471l-5.689-3.737A.87.87,0,0,1,164.741,35.931Zm0,0",
    transform: "translate(-141.028 -6.652)",
    fill: "#e6e6f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12144",
    "data-name": "Path 12144",
    d: "M30.84,413.4h30.9v10.3H30.84Zm0,0",
    transform: "translate(-27.351 -364.556)",
    fill: "#d6fffa"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12145",
    "data-name": "Path 12145",
    d: "M42.36,12.424H8.815A1.316,1.316,0,0,1,7.5,11.108V8.815A1.316,1.316,0,0,1,8.815,7.5H42.36a1.316,1.316,0,0,1,1.315,1.315v2.292A1.316,1.316,0,0,1,42.36,12.424Zm0,0",
    transform: "translate(-6.652 -6.652)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12146",
    "data-name": "Path 12146",
    d: "M277.6,7.5h-4.856v4.924H277.6a1.316,1.316,0,0,0,1.315-1.316V8.815A1.316,1.316,0,0,0,277.6,7.5Zm0,0",
    transform: "translate(-240.613 -6.652)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12147",
    "data-name": "Path 12147",
    d: "M42.36,465.9H8.815A1.315,1.315,0,0,1,7.5,464.581v-2.292a1.316,1.316,0,0,1,1.315-1.316H42.36a1.316,1.316,0,0,1,1.315,1.316v2.292A1.315,1.315,0,0,1,42.36,465.9Zm0,0",
    transform: "translate(-6.652 -406.745)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12148",
    "data-name": "Path 12148",
    d: "M32.055,136.922a13.225,13.225,0,0,0,5.839,9.172l5.689,3.6a.816.816,0,0,1,.382.692h6.8a.816.816,0,0,1,.382-.692l5.689-3.6a13.224,13.224,0,0,0,5.839-9.172Zm0,0",
    transform: "translate(-28.429 -120.708)",
    fill: "#d6fffa"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12149",
    "data-name": "Path 12149",
    d: "M164.358,150.39a.816.816,0,0,1,.382-.692l5.689-3.6a13.224,13.224,0,0,0,5.839-9.172h-6.2a13.227,13.227,0,0,1-5.839,9.172l-2.648,1.677a3.079,3.079,0,0,0-1.442,2.619Zm0,0",
    transform: "translate(-141.033 -120.708)",
    fill: "#7ecdc4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12150",
    "data-name": "Path 12150",
    d: "M238.8,322.269a10.925,10.925,0,1,1-10.925-10.925A10.925,10.925,0,0,1,238.8,322.269Zm0,0",
    transform: "translate(-190.709 -274.042)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12151",
    "data-name": "Path 12151",
    d: "M289.211,311.344a10.936,10.936,0,0,0-3.1.447,10.928,10.928,0,0,1,0,20.955,10.926,10.926,0,1,0,3.1-21.4Zm0,0",
    transform: "translate(-252.046 -274.042)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12152",
    "data-name": "Path 12152",
    d: "M259.578,346.086a7.887,7.887,0,1,1-7.886-7.887A7.887,7.887,0,0,1,259.578,346.086Zm0,0",
    transform: "translate(-214.527 -297.859)",
    fill: "#fafaff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12153",
    "data-name": "Path 12153",
    d: "M289.211,338.2a7.866,7.866,0,0,0-3.1.634,7.889,7.889,0,0,1,0,14.506,7.887,7.887,0,1,0,3.1-15.14Zm0,0",
    transform: "translate(-252.046 -297.859)",
    fill: "#e6e6f2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12154",
    "data-name": "Path 12154",
    d: "M307,369.134a1.061,1.061,0,0,1-1.04,1.04,1.04,1.04,0,1,1,1.04-1.04Zm-.306-2.721c0,.413-.444.581-.749.581-.4,0-.749-.168-.749-.581,0-2.018-.2-4.709-.2-6.727a.85.85,0,0,1,.948-.841.871.871,0,0,1,.964.841C306.906,361.7,306.692,364.394,306.692,366.412Zm0,0",
    transform: "translate(-269.128 -316.169)",
    fill: "#5dadae"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12155",
    "data-name": "Path 12155",
    d: "M48.938,47.8a12.2,12.2,0,0,0-16.1-11.555,14.591,14.591,0,0,0-2.278-2.081c-.21-.154-.427-.305-.647-.449l-.012-.007L24.042,30,29.9,26.289l.011-.007A14.534,14.534,0,0,0,36.5,14.088V6.859h.493a2.244,2.244,0,0,0,2.242-2.242V2.242A2.244,2.244,0,0,0,36.993,0H2.242A2.244,2.244,0,0,0,0,2.242V4.617A2.244,2.244,0,0,0,2.242,6.859h.493v7.229A14.535,14.535,0,0,0,9.324,26.282l.011.008L15.193,30,9.335,33.711l-.011.007A14.535,14.535,0,0,0,2.735,45.912v7.229H2.242A2.244,2.244,0,0,0,0,55.383v2.375A2.244,2.244,0,0,0,2.242,60H36.993c.061,0,.123,0,.185-.008A12.211,12.211,0,0,0,48.938,47.8ZM1.758,4.617V2.242a.484.484,0,0,1,.484-.484H36.993a.484.484,0,0,1,.484.484V4.617a.484.484,0,0,1-.484.484H2.242A.484.484,0,0,1,1.758,4.617Zm8.524,20.191a12.781,12.781,0,0,1-5.473-7.884H8.679a.879.879,0,0,0,0-1.758H4.538q-.045-.535-.045-1.078V6.859H34.742v7.229q0,.543-.045,1.078h-22.5a.879.879,0,1,0,0,1.758H34.427a12.776,12.776,0,0,1-5.473,7.884l-5.888,3.73a1.725,1.725,0,0,0-.565.581H16.734a1.726,1.726,0,0,0-.565-.581ZM2.242,58.242a.484.484,0,0,1-.484-.484V55.383a.484.484,0,0,1,.484-.484H23.768a.879.879,0,1,0,0-1.758H4.493V49.324H21.924a.879.879,0,1,0,0-1.758H4.493V45.912a12.782,12.782,0,0,1,5.788-10.72l5.888-3.73a1.731,1.731,0,0,0,.568-.585H22.5a1.725,1.725,0,0,0,.568.585l5.888,3.729c.191.126.381.257.564.392a12.791,12.791,0,0,1,1.6,1.4,12.193,12.193,0,0,0-.68,21.261Zm34.9-.007-.4.007a10.431,10.431,0,1,1,.4-.007Zm0,0",
    fill: "#5dadae"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12156",
    "data-name": "Path 12156",
    d: "M245.04,330.7a8.735,8.735,0,1,0,8.735,8.735A8.746,8.746,0,0,0,245.04,330.7Zm0,15.774a7.039,7.039,0,1,1,7.039-7.039A7.047,7.047,0,0,1,245.04,346.473Zm0,0",
    transform: "translate(-207.875 -291.208)",
    fill: "#5dadae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApprovals);
export default __webpack_public_path__ + "static/media/pending-approvals.7016751271b0b5f9684e16784ab3730a.svg";
export { ForwardRef as ReactComponent };